import React from 'react';
import '../less/transfers.less';
import hero_img from '../img/intel-express/hero_img.png';
import attention_icon from '../img/wu/attention_icon.svg'
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import CustomDropdownNew from '../../../../../auxiliary-components/shared/CustomDropdownNew';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import europaAndCisData from '../../../../../../API/transfers/iexpress/iexpress_ua.json';
import asianUSDEUR from '../../../../../../API/transfers/iexpress/iexpress_rates.json';
import { transfersAttentionUrl } from '../../../../../services/urls/urls';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'intel-express';

    const hero_data = {
      title: 'INTEL_EXPRESS_NEW_HERO_TITLE',
      text: 'INTEL_EXPRESS_HERO_TEXT'
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="intel-express">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <InfoBlock
                title={`INTEL_EXPRESS_NEW_INFO_TITLE_01`}
                text={`INTEL_EXPRESS_NEW_INFO_TEXT_01`}
              />
              <div className="intel-express__tariffs tariffs-intel-express">
                <TitleBlock title={'INTEL_EXPRESS_NEW_TARIFFS_TITLE'}/>
                <CustomDropdownNew title={this.l10n("INTEL_EXPRESS_TARIFFS_EU_CIS")} page={page} id={'tariffs-eu-cis'}>
                  <div>
                    <TransferTableNew data={europaAndCisData}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("INTEL_EXPRESS_TARIFFS_ASIA")} page={page} id={'tariffs-asia'}>
                  <div>
                    <TransferTableNew data={asianUSDEUR}/>
                  </div>
                </CustomDropdownNew>
              </div>
              <div className="intel-express__info-block">
                <InfoBlock 
                  text={'INTEL_EXPRESS_NEW_INFO_TEXT_02'}
                />
                <InfoBlock 
                  text={'INTEL_EXPRESS_NEW_INFO_TEXT_03'}
                />
                <div className="attention-block">
                  <div className="container">
                    <div className="attention-block__body">
                      <div className="attention-block__title">
                        <ReactSVG src={attention_icon} className="attention-block__icon"/>
                        {this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TITLE')}
                      </div>
                      <div className="attention-block__text">
                        <ul>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_01')}</li>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_02')}</li>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_03')}</li>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_04')}</li>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_05')}</li>
                          <li>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_06')}</li>
                          <li>
                            {this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_07_1')}
                            <a href={transfersAttentionUrl} target='_blank' rel='noopener noreferrer'>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_07_2')}</a>
                          </li>
                        </ul>
                        <p>
                          {this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_08')}
                          <a href="/about/general" target='_self' onClick={(e) => this.navigate("/about/general", e)}>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_LINK_01')}</a>
                        </p>
                        <p>
                          {this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_TEXT_09')}
                          <a href="/forpartners" target='_self' onClick={(e) => this.navigate("/forpartners", e)}>{this.l10n('INTEL_EXPRESS_NEW_ATTENTION_BLOCK_LINK_02')}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'INTEL_EXPRESS_NEW_QUESTIONS_TITLE'}
                page={page}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('INTEL_EXPRESS_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('INTEL_EXPRESS_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}
